import React from "react";

const IsCompleted = () => {
  return (
    <>
      <span className="tab-badge scheduled">Scheduled</span>
    </>
  );
};
export default IsCompleted;
